import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import FormHeader from "@/components/ui/organisms/MHeader";
import { MButton } from "@/components/ui/atoms/MButtons";
import MInputField from "@/components/ui/atoms/MInputField";
import { getMemberInfo } from "@/hooks/useMembers";
import MDropDownDrawer from "@/components/ui/molecules/MDropDownDrawer";
import MSpacer from "@/components/ui/atoms/MSpacer";

const AddPetDetails: React.FC = () => {
  const navigate = useNavigate();
  const memberInfo = getMemberInfo(true);
  const [petTypeDrawerOpen, setPetTypeDrawerOpen] = useState(false);
  const [petType, setPetType] = useState(() => {
    const saved = localStorage.getItem("add_member_form");
    return saved ? JSON.parse(saved).petType || "" : "";
  });
  const petTypeOptions = [
    { value: "dog", label: "Dog" },
    { value: "cat", label: "Cat" },
  ];
  const [breed, setBreed] = useState(() => {
    const saved = localStorage.getItem("add_member_form");
    return saved ? JSON.parse(saved).breed || "" : "";
  });
  const [genderDrawerOpen, setGenderDrawerOpen] = useState(false);
  const [gender, setGender] = useState(() => {
    const saved = localStorage.getItem("add_member_form");
    return saved ? JSON.parse(saved).gender || "" : "";
  });
  const genderOptions = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
  ];
  const [saving, setSaving] = useState(false);

  const allFilled = petType && breed && gender;

  // Map gender to backend number
  let genderNum = gender;
  if (typeof gender === "string") {
    if (gender.toLowerCase() === "male") genderNum = 1;
    else if (gender.toLowerCase() === "female") genderNum = 2;
    else if (gender.toLowerCase() === "other") genderNum = 3;
  }

  const handleNext = () => {
    const saved = localStorage.getItem("add_member_form");
    const form = saved ? JSON.parse(saved) : {};
    localStorage.setItem(
      "add_member_form",
      JSON.stringify({ ...form, petType, breed, gender })
    );
    navigate("/profile/family/add-member/pet-details/profile");
  };

  return (
    <div
      className="profile-page-root flex flex-col"
      style={{ minHeight: "calc(var(--vh, 1vh) * 100 - 128px)" }}
    >
      <FormHeader
        module="Family"
        memberInfo={memberInfo}
        title="Set up their profile"
        description="Add details to create their profile."
        learnMoreContent="We use these details to create a clear health profile for your pet, making it easier to manage their vet visits, vaccinations, and other records in one place. Their data stays private and secure."
      />
      <div className="flex-1">
        <MSpacer mt={34} />
        <div className="flex flex-col gap-[32px]">
          <MInputField
            label="Is it a cat or dog?"
            showLabel
            placeholder="Not Answered"
            variant="Underlined"
            size="md"
            value={
              petTypeOptions.find((opt) => opt.value === petType)?.label || ""
            }
            onClick={() => setPetTypeDrawerOpen(true)}
            readOnly
          />
          <MDropDownDrawer
            open={petTypeDrawerOpen}
            onClose={() => setPetTypeDrawerOpen(false)}
            title="Select Pet Type"
            items={petTypeOptions}
            initialValue={petType}
            variant="single"
            onSelect={(value: string | string[]) => {
              setPetType(
                typeof value === "string" ? value : (value as any)[0] || ""
              );
              setPetTypeDrawerOpen(false);
            }}
          />
          <MInputField
            label="What's their breed?"
            showLabel
            placeholder="Not Answered"
            variant="Underlined"
            size="md"
            value={breed}
            onChange={(e) => setBreed(e.target.value)}
          />
          <MInputField
            label="What is their gender?"
            showLabel
            placeholder={
              genderOptions.find((opt) => opt.value === gender)?.label ||
              "Not Answered"
            }
            variant="Underlined"
            size="md"
            value={
              genderOptions.find((opt) => opt.value === gender)?.label || ""
            }
            onClick={() => setGenderDrawerOpen(true)}
            readOnly
          />
          <MDropDownDrawer
            open={genderDrawerOpen}
            onClose={() => setGenderDrawerOpen(false)}
            title="Select Gender"
            items={genderOptions}
            initialValue={gender}
            variant="single"
            onSelect={(val: string | string[]) => {
              setGender(typeof val === "string" ? val : (val as any)[0] || "");
              setGenderDrawerOpen(false);
            }}
          />
        </div>
      </div>
      <div className="confirm-footer">
        <MButton
          variant="filled"
          size="lg"
          disabled={!allFilled || saving}
          onClick={handleNext}
          className="w-full"
        >
          Next
        </MButton>
      </div>
    </div>
  );
};

export default AddPetDetails;
